import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { USERS } from '../../constant';

type Payload = {
  /** Excludes the cardiologist the report is already assigned to (re-assignment). */
  reportId?: string;
};

/**
 * Cardiologists of the logged-in clinic — the single list behind every "assign a doctor"
 * surface. Replaces the two lists these screens used to mix (hospital doctors, which also
 * returned Radiologists/Clinicians, and fetchDoctorsToAssign, which returned everyone
 * except Sonographers and so offered Admins and Medical Receptionists as assignees).
 */
export const getCardiologists = createAsyncThunk(
  'getCardiologists',
  async (payload: Payload = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const query = payload?.reportId ? `?reportId=${encodeURIComponent(payload.reportId)}` : '';
      const response = await fetch(`${USERS.GET_CARDIOLOGISTS}${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch cardiologists');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
